<div class="gantt-header">
    <div class="gantt-header-title">
        <div style="flex:1">{{ name }}</div>
        <div>Started: {{ startDate}}</div>
    </div>
</div>


// WEBPACK FOOTER //
// /Users/shobhit/Documents/codes/arrivae-frontend/src/app/shared/gantt-chart/gantt-header/gantt-header.component.html